// Pages API interfaces based on OpenAPI specification
export interface PageLink {
  name: string;
  slug: string;
}

export interface Page {
  name: string;
  content_html: string;
  last_update_date: string;
}

export interface PagesListResponse {
  pages: PageLink[];
}

export interface ApiError {
  error: string;
}

class PagesApiService {
  private readonly baseUrl = 'https://moncopieur.cloud-erp.ma';

  private async handleResponse<T>(response: Response): Promise<T> {
    if (response.status === 404) {
      throw new Error('Page not found');
    }
    if (response.status === 403) {
      throw new Error('Page is not published');
    }
    if (!response.ok) {
      const errorData: ApiError = await response.json().catch(() => ({
        error: `HTTP ${response.status}: ${response.statusText}`
      }));
      throw new Error(errorData.error);
    }
    return response.json();
  }

  /**
   * Get list of footer pages (published)
   */
  async getFooterPages(): Promise<PagesListResponse> {
    const response = await fetch(`${this.baseUrl}/api/pages`);
    return this.handleResponse<PagesListResponse>(response);
  }

  /**
   * Get page by slug (published only)
   */
  async getPageBySlug(slug: string): Promise<Page> {
    const response = await fetch(`${this.baseUrl}/api/pages/${slug}`);
    return this.handleResponse<Page>(response);
  }
}

// Export singleton instance
export const pagesApi = new PagesApiService();
export default pagesApi;